/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuditStateEnum {
    DETACHED = 'Detached',
    UNCHANGED = 'Unchanged',
    DELETED = 'Deleted',
    MODIFIED = 'Modified',
    ADDED = 'Added',
}